import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { Tooltip } from "@mui/material";

export const SamplingType = {
	"*": "*",
	"1": "Closed",
	"2": "Partly open",
	"3": "Open",
} as const;

export const ProductSamplingTypeSelect = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return <Select
		disableSearch
		fetchOptions={Object.keys(SamplingType)}
		getOptionLabel={opt => getLabel(opt as keyof typeof SamplingType)}
		multiple={false}
		value={value}
		onChange={onChange}
	/>;
};

function getLabel(samplingType: keyof typeof SamplingType) {
	return samplingType === "*" ? "*" : `${samplingType}. ${SamplingType[samplingType]}`;
}

// eslint-disable-next-line react-refresh/only-export-components
export function productSamplingTypeField(samplingType: keyof typeof SamplingType | undefined) {
	if (!samplingType) {
		return "-";
	}
	if (samplingType === "*") {
		return "*";
	}
	return <Tooltip title={SamplingType[samplingType]} placement="right"><span>{samplingType}</span></Tooltip>;
}
